module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-15-169af3fa9e71a7e74f00e0465d34a3a9.svg";